import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';
import { useEarlyAdopter } from '@/contexts/EarlyAdopterContext';
import { createEarlyAdopterHandler } from '@/utils/earlyAdopterInterceptor';
import olderAdultsHero from '@/assets/illustrations/hero-older-adult.png';

const HeroSectionB = () => {
  const { openModal } = useEarlyAdopter();

  return (
    <section className="relative w-full min-h-[75vh] lg:min-h-[85vh] overflow-hidden">
      {/* Full-width background image */}
      <img
        src={olderAdultsHero}
        alt="Confident older adult living independently at home"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-transparent" />

      {/* Content */}
      <div className="relative h-full min-h-[75vh] lg:min-h-[85vh] flex items-center">
        <div className="container mx-auto px-4 md:px-8 lg:px-12">
          <div className="max-w-2xl pt-24 md:pt-32 pb-20 md:pb-28">
            <div className="bg-black/50 backdrop-blur-sm rounded-2xl p-8 md:p-10 text-left">
              {/* Badge */}
              <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20 w-fit mb-6">
                <span className="text-sm font-semibold text-white uppercase tracking-wider">ThriveMax</span>
              </div>

              {/* Headline */}
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4 tracking-tight leading-[1.1] drop-shadow-lg">
                Stay Independent at Home.{' '}
                <span className="text-primary-foreground">We'll Help You Do It Safely.</span>
              </h1>

              {/* Subheadline */}
              <p className="text-lg sm:text-xl lg:text-2xl text-white/90 mb-6 leading-relaxed drop-shadow-md">
                The biggest risks to independence show up quietly, in everyday moments at home. SeniorThrive helps you notice early, make smart adjustments, and keep living life on your terms.
              </p>

              {/* Trust line */}
              <div className="flex items-center gap-3 text-white/80 mb-6">
                <ShieldCheckIcon className="w-5 h-5" />
                <span className="font-medium">Private. Secure. Always on your terms.</span>
              </div>

              {/* CTA */}
              <div className="flex flex-col sm:flex-row gap-4 mb-4">
                <Button
                  size="lg"
                  className="text-lg px-8 py-6 rounded-xl font-semibold bg-primary hover:bg-primary/90 text-primary-foreground shadow-xl"
                  onClick={createEarlyAdopterHandler(openModal, 'Older Adults Hero - Request Early Access')}
                >
                  Request Early Access
                  <ArrowRightIcon className="w-5 h-5 ml-2" />
                </Button>
              </div>

              <p className="text-sm text-white/70">
                Works instantly on your phone, tablet, or computer.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSectionB;
